export default __webpack_public_path__ + "static/media/1.479d6821.jpg";